var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showBanner
    ? _c("div", { ref: "privacyBanner", staticClass: "privacy-banner" }, [
        _c("div", { staticClass: "container" }, [
          _c("p", [
            _c("b", [
              _vm._v("We use cookies to improve your experience on Brilliant.")
            ]),
            _vm._v(" "),
            _vm.$route.name === "flatpage_cookiepolicy"
              ? _c("span", [
                  _vm._v(
                    "\n        Here you can learn more about how and why we use cookies, and change your preferences at\n        any time.\n      "
                  )
                ])
              : _c("span", [
                  _vm._v(
                    "\n        You can learn more about how and why we use cookies in our cookie policy, where you can\n        change your preferences at any time.\n      "
                  )
                ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "actions" }, [
            _vm.$route.name !== "flatpage_cookiepolicy"
              ? _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.$router.resolve({
                        name: "flatpage_cookiepolicy"
                      }).href
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.clickPreferences({
                          name: "flatpage_cookiepolicy"
                        })
                      }
                    }
                  },
                  [_vm._v("Policy & Preferences")]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-accent",
                on: { click: _vm.dismissBanner }
              },
              [_vm._v("Got it")]
            )
          ])
        ]),
        _vm._v(" "),
        _c("button", {
          staticClass: "close b-sprite-global-close-black",
          on: { click: _vm.dismissBanner }
        })
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }